import RepeatReferralContainer from './repeat-referral-container';

export default RepeatReferralContainer;
